var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('div',{staticClass:"app-container"},[_c('div',{attrs:{"id":"feishu-user-profile"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }